import React from 'react'
import { Popup } from 'semantic-ui-react'

/** @param {import('semantic-ui-react').PopupProps} props */
export default function BarePopup({ style, ...props }) {
  return (
    <Popup basic on="click" position="bottom left" style={{ ...noStyle, ...style }} {...props} />
  )
}

const noStyle = {
  padding: 0,
  background: 'none',
  border: 'none',
  boxShadow: 'none',
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/BarePopup/index.js